import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import { ArrowRight } from "lucide-react";

const STEPS = [
  {
    n: 1,
    title: "Who Is God?",
    body: "Start with the God who was there before everything else — infinite, holy, loving, one.",
    to: "/what-we-believe/the-one-true-god",
  },
  {
    n: 2,
    title: "Who Is Jesus Christ?",
    body: "The eternal Son of God, born as one of us, crucified for us, risen for us. See who He truly is.",
    to: "/know-jesus",
  },
  {
    n: 3,
    title: "What Is the Bible?",
    body: "One story from Genesis to Revelation about God rescuing His world through Jesus Christ.",
    to: "/articles/how-to-begin-reading-the-bible",
  },
  {
    n: 4,
    title: "What Is Sin?",
    body: "The Bible's honest diagnosis: not merely bad behaviour but a rebel heart cut off from life.",
    to: "/what-we-believe/sin-and-the-fall",
  },
  {
    n: 5,
    title: "What Is Salvation?",
    body: "God's gift in Jesus Christ — received by grace through faith, not by earning.",
    to: "/what-we-believe/salvation-by-grace",
  },
  {
    n: 6,
    title: "How Can I Be Forgiven?",
    body: "One honest prayer, one act of trust. Real forgiveness for anyone who will come.",
    to: "/articles/how-can-i-be-forgiven",
  },
  {
    n: 7,
    title: "How to Begin Reading the Bible",
    body: "Start with the Gospel of John. A gentle guide for first-time readers.",
    to: "/articles/how-to-begin-reading-the-bible",
  },
  {
    n: 8,
    title: "How to Pray",
    body: "Simple, honest conversation with the Father through Jesus Christ.",
    to: "/articles/how-should-i-pray",
  },
];

export default function StartHere() {
  return (
    <>
      <PageHero
        eyebrow="Start here"
        title="New to Christianity? Welcome."
        subtitle="If you are exploring Christianity for the first time — or the fiftieth — this page is for you. No pressure. No agenda. Just a clear, careful path through the essentials."
      />
      <section className="py-16 sm:py-24">
        <div className="container-editorial">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {STEPS.map((s) => (
              <Link
                key={s.n}
                to={s.to}
                data-testid={`start-step-${s.n}`}
                className="group flex items-start gap-6 paper-card p-8 hover:border-ink transition-colors"
              >
                <span className="font-serif text-4xl text-gold shrink-0" style={{ fontWeight: 500 }}>0{s.n}</span>
                <div>
                  <h3 className="heading-3 group-hover:text-forest transition-colors">{s.title}</h3>
                  <p className="body-copy mt-3 text-ink-muted">{s.body}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm uppercase tracking-widest text-ink group-hover:text-forest">
                    Read <ArrowRight className="h-3.5 w-3.5" />
                  </span>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-16 paper-card p-10 bg-subtle text-center">
            <h3 className="heading-3">Have a question?</h3>
            <p className="body-copy mt-4 text-ink-muted max-w-xl mx-auto">
              You are not required to have your questions figured out before coming to Christ. Ask honestly — we will
              answer thoughtfully.
            </p>
            <div className="mt-6 flex items-center justify-center gap-4 flex-wrap">
              <Link to="/questions" className="btn-primary">Questions & Answers</Link>
              <Link to="/contact#ask" className="btn-ghost">Ask a Question</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
